<div *ngIf="loading | async" class="progress-container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<app-header></app-header>
<div class="container">
  <div class="gears-animation-container" *ngIf="gearsAnimation | async">
    <img src="assets/img/HDI_Gears_Animation.gif" alt="Gears Animation">
    <span>Wir verarbeiten Ihre Angaben...</span>
  </div>
  <div [class.container-gears-animation]="gearsAnimation | async">
    <router-outlet></router-outlet>
  </div>
</div>
<div [ngClass]="(praemie | async) ? 'footer-container-praemie' : 'footer-container'">
  <div class="footer">
    <div class="footer__meta">
      <div *ngIf="praemie | async as result">
        <div *ngIf="result" class="praemie-status">
          <div class="praemie-grid">
            <div class="praemie-text">{{ result.ZahlungArtId === 1 ? 'Jährliche' : result.ZahlungArtId === 2 ? 'Halbjährliche' : result.ZahlungArtId === 3 ? 'Vierteljährliche' : result.ZahlungArtId === 4 ? 'Monatliche' : null }} Prämie:</div>
            <div class="praemie-value custom_currency">{{ (result.Praemie ? result.Praemie : 0) | customCurrency }}</div>
            <div class="praemie-append">
              <span class="praemie-full-text">inkl. aller möglichen Steuern</span>
              <span class="praemie-short-text">inkl. aller mögl. Steuern</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        &copy; {{ currentYear }} HDI Versicherung AG
      </div>
    </div>
  </div>
</div>
